module.exports = __webpack_public_path__ + "static/media/sg12cr0.6862dc5c.png";